var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEggs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3802_3753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1562 4.35938C6.02656 4.35938 0.5 14.5687 0.5 23.3438C0.5 30.3258 6.17422 36 13.1562 36C20.1383 36 25.8125 30.3258 25.8125 23.3438C25.8125 14.5687 20.2859 4.35938 13.1562 4.35938Z",
    fill: "#FAECD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 18.9844C36.5 25.9664 30.8258 31.6406 23.8437 31.6406C23.2741 31.6406 22.7257 31.5984 22.1984 31.5352L15.364 5.33665C17.7687 1.89837 20.764 0 23.8437 0C30.9734 0 36.5 10.2093 36.5 18.9844Z",
    fill: "#FFBD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 18.9844C36.5 25.9664 30.8258 31.6406 23.8438 31.6406V0C30.9734 0 36.5 10.2093 36.5 18.9844Z",
    fill: "#F6A96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1562 14.9062C8.49446 14.9062 4.71875 18.682 4.71875 23.3438C4.71875 28.0054 8.49446 31.7812 13.1562 31.7812C17.818 31.7812 21.5938 28.0054 21.5938 23.3438C21.5938 18.682 17.818 14.9062 13.1562 14.9062Z",
    fill: "#FEBE39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8125 23.3438C25.8125 30.3258 20.1383 36 13.1562 36V4.35938C20.2859 4.35938 25.8125 14.5687 25.8125 23.3438Z",
    fill: "#F4D7AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5938 23.3438C21.5938 28.0054 17.818 31.7812 13.1562 31.7812V14.9062C17.818 14.9062 21.5938 18.682 21.5938 23.3438Z",
    fill: "#B9810C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3802_3753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggs);
export default __webpack_public_path__ + "static/media/eggs.66958e42be4fde4c7caa7f1c62202f30.svg";
export { ForwardRef as ReactComponent };